import DownNewsletterContainer from './DownNewsletterContainer';
export default DownNewsletterContainer;
